export const stringToKey = (value) => value.toLowerCase().replace(/[^0-9a-z]/gi, '');